import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WorkspaceFilesUserStatusListWarningDirective } from './workspace-files-user-status-list-warning.directive';

@NgModule({
  declarations: [
    WorkspaceFilesUserStatusListWarningDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    WorkspaceFilesUserStatusListWarningDirective
  ]
})
export class WorkspaceFilesUserStatusListWarningModule { }
